<template>
  <div id="app">
    <homeComponent />
  </div>
</template>

<script>
  import homeComponent from '@/views/index.vue'
  export default {
    name: 'App',
    components:{homeComponent}
  }
</script>

<style>
  *{
    margin: 0;
    padding: 0;
  }
  img,video{
    vertical-align: middle;
  }
  a{
    text-decoration: none;
  }
  ::-webkit-scrollbar{width:0;}
  .el-pager li{
    font-size: 18px;
    color:#666666;
    transition: all 600ms;
  }
  .el-pager li:hover{
    color:#E4071A;
  }
  .el-pager li.active{
    color:#E4071A;
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .f14{
    font-size: 14px;
  }
  .f30{
    font-size: 30px;
  }
  .f60{
    font-size: 60px;
  }
  .f18{
    font-size: 18px;
  }
  .thide{
    overflow:hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  @media screen and (max-width: 1500px){
    .f60{
      font-size: 40px;
    }
  }
</style>
